export const titleStyle = {
  marginBottom: 24,
};
